// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Banner_TheComp__pqmoL"};